import $ from 'jquery';
import { EdgeResizer } from '~src/utils';
import { getImageSize } from './getImageSize';

export const displayPhotoInfo = async (photoItemId) => {
  $('.spinner-grow').prop('hidden', false);

  const photoItem = window.editorConfig.sidebarAttachments.items.find(
    (item) => item.objectId === photoItemId
  );

  if (!$(`#preview-photo-${photoItem.objectId}`).length) {
    $('#box-photo-container').remove();
    const imageSize = await getImageSize(photoItem.allegato.url);
    const previewImg = new EdgeResizer(photoItem.allegato.url).scaleToWidth(
      200
    );

    let photoHtml = `
    <div id="box-photo-container" class="box-tag-image-container">
      <div id="preview-photo-${photoItem.objectId}" class="items-tag-image-container">
        <img src="../assets/svg/img-loader.gif" class="lazy items-tag-image" data-src="${previewImg}" />
      </div>
      <div class="tag-preview-background-container-description">
        <div class="tag-preview-background-container-description-title">
          Dimensioni:
        </div>
        <div class="tag-preview-background-container-description-text">
          Altezza: ${imageSize.h} px - Larghezza: ${imageSize.w} px <br>
          Peso: ${imageSize.s} MB
        </div>
      </div>
    </div>
    `;

    $('.spinner-grow').prop('hidden', true);
    $('#photo-container').append(photoHtml);
    window.lazyLoadInstance.update();
  }
};
